import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { PageHeader, StatusBadge, EmptyState, Loading, Pager, Card } from "../../components/common";
import { api } from "../../lib/api";
import { pkr, fmtDate, ORDER_STATUS } from "../../lib/format";

const FILTERS = [["", "All"], ["submitted,confirmed,payment_pending,paid,processing,shipped,delivered", "In progress"], ["completed", "Completed"], ["cancelled,refunded", "Cancelled / Refunded"]];

export default function MyOrders() {
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/orders/mine", { params: { status, q, page } }).then((r) => setData(r.data)), 250);
    return () => clearTimeout(t);
  }, [status, q, page]);
  return (
    <div>
      <PageHeader title="My Orders" subtitle="Orders you booked with your Sales ID." actions={<Button asChild data-testid="my-orders-book-btn"><Link to="/app/book">Book an Order</Link></Button>} />
      <div className="mb-4 flex flex-col gap-3 sm:flex-row">
        <Input data-testid="my-orders-search" placeholder="Search order no. or customer" value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} className="h-11 sm:max-w-xs" />
        <div className="flex gap-2 overflow-x-auto">{FILTERS.map(([v, l]) => (
          <button key={l} onClick={() => { setStatus(v); setPage(1); }} data-testid={`my-orders-filter-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium ${status === v ? "border-[#0B192C] bg-[#0B192C] text-white" : "bg-white text-slate-700"}`}>{l}</button>
        ))}</div>
      </div>
      {!data ? <Loading /> : data.items.length === 0 ? <EmptyState icon={ClipboardList} title="No orders here" message="Orders you book will appear here with their latest status." action={<Button asChild><Link to="/app/deals">Find Deals</Link></Button>} /> : (
        <>
          <div className="space-y-3">
            {data.items.map((o) => (
              <Link key={o.id} to={`/app/orders/${o.id}`} data-testid={`my-order-row-${o.order_no}`}>
                <Card className="mb-3 flex flex-col gap-3 p-4 hover:shadow-md sm:flex-row sm:items-center sm:justify-between">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2"><span className="font-mono font-bold">{o.order_no}</span><StatusBadge map={ORDER_STATUS} value={o.status} /></div>
                    <p className="mt-1 truncate text-sm text-slate-600">{o.deal.name} × {o.quantity} · {o.customer.name}</p>
                    <p className="text-xs text-slate-400">{fmtDate(o.created_at)}</p>
                  </div>
                  <div className="flex gap-6 sm:text-right">
                    <div><p className="text-[11px] uppercase text-slate-500">Total</p><p className="font-mono font-bold">{pkr(o.total_amount)}</p></div>
                    <div><p className="text-[11px] uppercase text-emerald-700">Commission</p><p className="font-mono font-bold text-emerald-700">{pkr(o.commission_amount)}</p></div>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
          <Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} />
        </>
      )}
    </div>
  );
}
